<template>
  <a
    :href="url"
    target="_blank"
    class="group space-y-6 rounded-lg border border-neutral-80 bg-white p-6 hover:border-primary-40 hover:shadow"
  >
    <div class="flex justify-between">
      <div
        :class="[
          // {
          //   'bg-teal-50 text-teal-700': theme === 'teal',
          //   'bg-orange-50 text-orange-700': theme === 'orange',
          //   'bg-rose-50 text-rose-700': theme === 'rose',
          //   'bg-indigo-50 text-indigo-700': theme === 'indigo',
          // },
          'rounded-lg bg-primary-99 p-3 text-primary-40',
        ]"
      >
        <component :is="icon" class="h-6 w-6" />
      </div>
      <ExternalLinkIcon class="h-5 w-5 text-primary-40" />
    </div>
    <div class="space-y-2">
      <h1 class="m-0 text-base font-medium text-neutral-0">{{ title }}</h1>
      <p class="text-sm font-normal text-neutral-40">
        {{ description }}
      </p>
    </div>
  </a>
</template>

<script lang="ts" setup>
import type { FunctionalComponent } from "vue";

// Icon
import { ExternalLinkIcon } from "@heroicons/vue/outline";

const props = defineProps<{
  title: string;
  description: string;
  icon: FunctionalComponent;
  url: string;
  theme: "teal" | "orange" | "rose" | "indigo";
}>();
</script>
